module.exports = __webpack_public_path__ + "img/app_banner.45835044.png";